import { defineStore } from 'pinia'

export const useSessionStore = defineStore('session', {
  state: () => ({
    user: null
  }),
  getters: {
    hasPermission: (state) => (perms) => {
      if (!state.user?.permissions) return false

      // Se for string → transforma em array
      const list = Array.isArray(perms) ? perms : [perms]

      // Verifica se o utilizador tem pelo menos uma das permissões
      return list.some(p => state.user.permissions.includes(p))
    },
    hasRole: (state) => (roles) => {
      if (!state.user?.roles) return false

      // Se for string → converte em array
      const list = Array.isArray(roles) ? roles : [roles]

      // Verifica se existe interseção
      return state.user.roles.some(role => list.includes(role))
    },
    belongsToDepartments: (state) => (departmentIdsToCheck) => {
      if(!state?.user?.departments) return false;

      let userDepartmentIds = Array.isArray(state?.user?.departments)
                          ? state.user.departments
                          : [];
      userDepartmentIds = userDepartmentIds.map((dep) => dep?.id).filter(Boolean);
      userDepartmentIds = new Set(userDepartmentIds);

      departmentIdsToCheck = Array.isArray(departmentIdsToCheck) ? departmentIdsToCheck : [departmentIdsToCheck];

      departmentIdsToCheck = new Set(departmentIdsToCheck);

      return [...userDepartmentIds].some((departmentId) =>
          departmentIdsToCheck.has(departmentId),
      );


    }
  }
})
